// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Heart = createSvgIcon(
  { All: <React.Fragment><g><path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M2.084 2.2405C3.5294.5865 5.873.566 7.3183 2.22L8 3l.6817-.7801c1.4454-1.654 3.7889-1.6334 5.2343.0206 1.4453 1.654 1.4453 4.6055 0 6.2595L8 15 2.084 8.5c-1.4453-1.654-1.4453-4.6055 0-6.2595z" clipRule="evenodd" /></g><defs></defs></React.Fragment>, },
  'small'
);
